import React, { CSSProperties } from 'react';
import styles from './DefaultUserPhoto.module.scss';

interface DefaultUserPhotoProps {
  style?: CSSProperties;
}

const DefaultUserPhoto: React.FC<DefaultUserPhotoProps> = ({ style }) => (
  <div className={styles.wrapper} style={style}>
    <i className="fas fa-user" />
  </div>
);



export default DefaultUserPhoto;
